import { Workspace, WorkspaceOrg } from './models';

const LOAD_WORKSPACES = '[Workspaces] Load Workspaces';
const LOAD_WORKSPACES_SUCCESS = '[Workspaces] Load Workspaces Success';
const LOAD_WORKSPACES_FAILURE = '[Workspaces] Load Workspaces Failure';
const LOAD_WORKSPACE_BY_ID = '[Workspaces] Load Workspace By Id';
const LOAD_WORKSPACE_BY_ID_SUCCESS = '[Workspaces] Load Workspace By Id Success';
const LOAD_WORKSPACE_BY_ID_FAILURE = '[Workspaces] Load Workspace By Id Failure';
const LOAD_WORKSPACE_ORGS = '[Workspaces] Load Workspace Orgs';
const LOAD_WORKSPACE_ORGS_SUCCESS = '[Workspaces] Load Workspace Orgs Success';
const LOAD_WORKSPACE_ORGS_FAILURE = '[Workspaces] Load Workspace Orgs Failure';
const CLEAR_WORKSPACE_ORGS = '[Workspaces] Clear Workspace Orgs';

const loadWorkspaces = (search?: string) => ({ type: LOAD_WORKSPACES, payload: { search } });
const loadWorkspacesSuccess = (payload: Workspace[]) => ({ type: LOAD_WORKSPACES_SUCCESS, payload });
const loadWorkspacesFailure = (payload: string) => ({ type: LOAD_WORKSPACES_FAILURE, payload });

const loadWorkspaceById = (workspaceId: string) => ({ type: LOAD_WORKSPACE_BY_ID, payload: { workspaceId } });
const loadWorkspaceByIdSuccess = (workspace: Workspace) => ({ type: LOAD_WORKSPACE_BY_ID_SUCCESS, payload: workspace });
const loadWorkspaceByIdFailure = (error: string) => ({ type: LOAD_WORKSPACE_BY_ID_FAILURE, payload: error });

const loadWorkspaceOrgs = (workspaceId: string) => ({ type: LOAD_WORKSPACE_ORGS, payload: { workspaceId } });
const loadWorkspaceOrgsSuccess = (workspaceId: string, orgs: WorkspaceOrg[]) => ({
  type: LOAD_WORKSPACE_ORGS_SUCCESS,
  payload: { workspaceId, orgs }
});
const loadWorkspaceOrgsFailure = (error: string) => ({ type: LOAD_WORKSPACE_ORGS_FAILURE, payload: error });
const clearWorkspaceOrgs = () => ({ type: CLEAR_WORKSPACE_ORGS });

export default {
  LOAD_WORKSPACES,
  LOAD_WORKSPACES_SUCCESS,
  LOAD_WORKSPACES_FAILURE,
  LOAD_WORKSPACE_BY_ID,
  LOAD_WORKSPACE_BY_ID_SUCCESS,
  LOAD_WORKSPACE_BY_ID_FAILURE,
  LOAD_WORKSPACE_ORGS,
  LOAD_WORKSPACE_ORGS_SUCCESS,
  LOAD_WORKSPACE_ORGS_FAILURE,
  CLEAR_WORKSPACE_ORGS,
  loadWorkspaces,
  loadWorkspacesSuccess,
  loadWorkspacesFailure,
  loadWorkspaceById,
  loadWorkspaceByIdSuccess,
  loadWorkspaceByIdFailure,
  loadWorkspaceOrgs,
  loadWorkspaceOrgsSuccess,
  loadWorkspaceOrgsFailure,
  clearWorkspaceOrgs
};
